module.exports = __webpack_public_path__ + "img/500.b5ff2f7e.svg";